import { BRANCH_STORAGE_KEY, FORM_DIRTY_PREFIX } from "./branch";

export const PRESENCE_KEY = "tt_last_seen";

export const PRESENCE_STALE_MS = 30 * 60_000;

const EXACT_KEYS = [
    "token",
    "username",
    "employeename",
    "employeeid",
    "menus",
    "submenus",
    "roleid",
    BRANCH_STORAGE_KEY,
    "tt_logout_signal",
    PRESENCE_KEY,
];

const PREFIXES = [
    "booking_tab_lock:",
    "booking_tab_heartbeat:",
    FORM_DIRTY_PREFIX,
];

const removeKeys = (keys: string[]): void => {
    keys.forEach((k) => {
        try {
            localStorage.removeItem(k);
        } catch {
        }
    });
};

export const clearTabState = (): void => {
    try {
        removeKeys(
            Object.keys(localStorage).filter((k) =>
                PREFIXES.some((prefix) => k.startsWith(prefix))
            )
        );
    } catch {
    }

    try {
        window.name = "";
    } catch {
    }
};

export const clearSession = (): void => {
    clearTabState();
    removeKeys(EXACT_KEYS);
};

export const touchPresence = (): void => {
    try {
        localStorage.setItem(PRESENCE_KEY, String(Date.now()));
    } catch {
    }
};

export const isColdStart = (): boolean => {
    try {
        const lastSeen = Number(localStorage.getItem(PRESENCE_KEY) || "0");
        return Date.now() - lastSeen > PRESENCE_STALE_MS;
    } catch {
        return true;
    }
};